<div class="menu-item-content">
  <hyperkit-typography variant="body" size="md" align="left" color="inherit">{{
    label
  }}</hyperkit-typography>
</div>
